import Http from './http';
import Loc from './loc';
import Jwt from './jwt';
import Storage from './storage';
import VueScroller from "vue-scroller"

let isInstalled = false;
export default {
  install(Vue, { apis }) {
    if (!isInstalled) {
      Vue.use(new Http(apis));
      Vue.use(new Loc());
      Vue.use(new Jwt());
      Vue.use(new Storage());
      Vue.use(VueScroller);
      isInstalled = true;
    }
  }
}
